import { InputAdornment, Stack } from 'ui';

import { TextField } from '../TextField/TextField';

type Props = {
  minName: string;
  maxName: string;
  required?: boolean;
  label: string;
  endAdornment?: string;
};
export const RangeField = ({ minName, maxName, label, required, endAdornment }: Props) => {
  return (
    <Stack direction="row" spacing={2}>
      <TextField
        name={minName}
        label={label}
        required={required}
        InputProps={{
          endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment>,
          startAdornment: <InputAdornment position="start">Min:</InputAdornment>,
        }}
      />
      <TextField
        name={maxName}
        label={label}
        required={required}
        InputProps={{
          endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment>,
          startAdornment: <InputAdornment position="start">Max:</InputAdornment>,
        }}
      />
    </Stack>
  );
};
